/**
 * Model reprezentujący konfigurację gatunku zwierzęcia (Pet Species)
 * w kontekście konkretnej kliniki weterynaryjnej.
 * Pozwala lecznicy na nadpisywanie globalnego słownika gatunków własnymi
 * nazwami, kolejnością oraz włączanie/wyłączanie obsługiwanych zwierząt.
 */
export class VetClinicPetSpecies {

  /** Wewnętrzny, numeryczny identyfikator w bazie danych. */
  public id: number;

  /** Globalnie unikalny identyfikator tego konkretnego wpisu dla kliniki. */
  public uuid: string;

  /** Identyfikator placówki weterynaryjnej, do której należy ten wpis. */
  public vetcodeId: number;

  /** Referencja do globalnego słownika gatunków.
   */
  public petSpeciesUUID: string;

  /** Systemowy klucz gatunku, używany w logice kodu i tłumaczeniach. */
  public key: string;

  /** Główna nazwa wyświetlana pacjentom. */
  public name: string;

  /** Forma męska nazwy gatunku.
   */
  public maleName: string;

  /** Forma żeńska nazwy gatunku. */
  public femaleName: string;

  /** Główny przełącznik (Toggle).
   * Jeśli klinika nie przyjmuje np. gadów, ustawia enabled na false,
   * a gatunek znika z kreatora rezerwacji dla tej placówki.
   */
  public enabled: boolean;

  /** Pozycja na liście rozwijanej (Sort Order).
   * Pozwala klinice umieścić najpopularniejsze gatunki (np. Psy i Koty) na samej górze.
   */
  public orderIndex: number;

  /** Identyfikator użytkownika, który utworzył tę konfigurację. */
  public authorUUID: string;

  /** Identyfikator użytkownika, który jako ostatni zmodyfikował ten wpis. */
  public editorUUID: string;

  /** Data i czas utworzenia rekordu. */
  public created: string;

  /** Data i czas ostatniej modyfikacji. */
  public modified: string;

  /** Kod grupy gatunku zwierzęcia (np. BIRDS) */
  groupCode: string;

}
